function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Component } from 'react';
import PropTypes from "prop-types";
import { Widget, WidgetHeader, WidgetBody, WidgetFooter, WidgetTitle, WidgetLoading, FormatMetric } from "../";
import { Chart } from "../";
import _ from "lodash";
import { getGaChartByType } from "../../resources/functions/";
import "./AnalyticsReportCountries.scss";

class AnalyticsReportCountries extends Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "state", {
      loading: true,
      chart: undefined,
      values: {}
    });

    _defineProperty(this, "componentDidUpdate", (prevProps, prevState) => {
      if (prevProps.report !== this.props.report) {
        this.getChart();
      }
    });

    _defineProperty(this, "getChart", () => {
      const report = this.props.report;

      if (!report) {
        return false;
      }

      const chart = getGaChartByType("choropleth", report);
      chart.data = _.orderBy(chart.data, 'value', 'desc'); // Use Lodash to sort array by 'value'

      this.setState({
        chart: chart,
        loading: false
      });
    });

    _defineProperty(this, "renderChart", () => {
      const theme = this.props.theme;
      const chart = this.state.chart;
      return React.createElement(Chart, _extends({}, chart, {
        theme: theme,
        type: "choropleth",
        projectionScale: 50
      }));
    });

    _defineProperty(this, "renderItem", (item, index) => {
      const theme = this.props.theme;
      const total = this.state.chart.total;
      let name = item.name,
          value = item.value,
          id = item.id;
      const percentage = value / total * 100;
      const barStyle = {
        backgroundColor: theme.primaryColor || 'black',
        width: percentage + "%"
      };

      if (!name) {
        name = "N/A";
      }

      return React.createElement("li", {
        key: index,
        className: "list-item"
      }, React.createElement("b", {
        className: "list-item__label"
      }, name), React.createElement("i", {
        className: "sparkline"
      }, React.createElement("i", {
        className: "sparkline__bar",
        style: barStyle,
        "data-value": value
      })), React.createElement("b", {
        className: "list-item__value"
      }, React.createElement(FormatMetric, {
        type: "PERCENT",
        value: percentage,
        decimals: "1"
      })));
    });

    _defineProperty(this, "renderList", () => {
      const data = this.state.chart.data;
      const top5 = data.slice(0, 5);
      return React.createElement("ul", {
        className: "list"
      }, top5.map(this.renderItem));
    });
  }

  componentDidMount() {
    this.getChart();
  }

  render() {
    const _this$props = this.props,
          theme = _this$props.theme,
          reportType = _this$props.reportType,
          scope = _this$props.scope,
          title = _this$props.title,
          loadingTitle = _this$props.loadingTitle,
          loadingDescription = _this$props.loadingDescription;
    const chart = this.state.chart;
    const loading = this.state.loading || this.props.loading;

    if (loading) {
      return React.createElement(Widget, this.props, React.createElement(WidgetLoading, {
        theme: theme,
        title: loadingTitle,
        description: loadingDescription
      }));
    }

    return React.createElement(Widget, this.props, React.createElement(WidgetHeader, null, React.createElement(WidgetTitle, {
      title: title
    })), this.renderChart(), React.createElement(WidgetBody, null, this.renderList()));
  }

}

_defineProperty(AnalyticsReportCountries, "defaultProps", {
  reportType: "countries",
  widgetType: "analytics-countries",
  widgetSize: "1:4",
  report: undefined,
  title: "Besøk etter land",
  loadingTitle: "Besøk etter land"
});

AnalyticsReportCountries.propTypes = process.env.NODE_ENV !== "production" ? {
  title: PropTypes.string,
  loadingTitle: PropTypes.string,
  loadingDescription: PropTypes.string,
  scope: PropTypes.string
} : {};
export default AnalyticsReportCountries;